// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CognitiveScreeningModule-module__font-s-10___aforJ {
  font-size: 10px !important;
}

.CognitiveScreeningModule-module__font-s-12___lMH6g {
  font-size: 12px !important;
}

.CognitiveScreeningModule-module__font-s-13___OuA68 {
  font-size: 13px !important;
}

.CognitiveScreeningModule-module__font-s-14___c76oz {
  font-size: 14px !important;
}

.CognitiveScreeningModule-module__font-s-15___WCUIm {
  font-size: 15px !important;
}

.CognitiveScreeningModule-module__font-s-16___mVNkb {
  font-size: 16px !important;
}

.CognitiveScreeningModule-module__font-s-18___PcmPz {
  font-size: 18px !important;
}

.CognitiveScreeningModule-module__font-s-20___H37bR {
  font-size: 20px !important;
}

.CognitiveScreeningModule-module__font-s-22___hTyRF {
  font-size: 22px !important;
}

.CognitiveScreeningModule-module__font-s-28___Hbq1B {
  font-size: 28px !important;
}

.CognitiveScreeningModule-module__font-w-400___QoDHE {
  font-weight: 400 !important;
}

.CognitiveScreeningModule-module__font-w-500___t6jXc {
  font-weight: 500 !important;
}

.CognitiveScreeningModule-module__font-w-600___EoQSN {
  font-weight: 600 !important;
}

.CognitiveScreeningModule-module__font-w-700____qnvG {
  font-weight: 700 !important;
}

.CognitiveScreeningModule-module__p-5___uyw1s {
  padding: 5px !important;
}

.CognitiveScreeningModule-module__p-12___zuHtB {
  padding: 12px !important;
}

.CognitiveScreeningModule-module__p-16___MVLSF {
  padding: 16px !important;
}

.CognitiveScreeningModule-module__p-30___kxaIf {
  padding: 30px !important;
}

.CognitiveScreeningModule-module__p-b-0___Aw6Vj {
  padding-bottom: 0 !important;
}

.CognitiveScreeningModule-module__p-b-5___AjRbY {
  padding-bottom: 5px !important;
}

.CognitiveScreeningModule-module__p-b-10___rHTjV {
  padding-bottom: 10px !important;
}

.CognitiveScreeningModule-module__p-b-12___bWPvi {
  padding-bottom: 12px !important;
}

.CognitiveScreeningModule-module__p-b-16___FOO6d {
  padding-bottom: 16px !important;
}

.CognitiveScreeningModule-module__p-b-18___BiNvf {
  padding-bottom: 18px !important;
}

.CognitiveScreeningModule-module__p-b-20___ohCpn {
  padding-bottom: 20px !important;
}

.CognitiveScreeningModule-module__p-b-25___iaKZM {
  padding-bottom: 25px !important;
}

.CognitiveScreeningModule-module__p-b-30___cQmo3 {
  padding-bottom: 30px !important;
}

.CognitiveScreeningModule-module__p-b-50___dkf0b {
  padding-bottom: 50px !important;
}

.CognitiveScreeningModule-module__p-t-0___UBjF2 {
  padding-top: 0 !important;
}

.CognitiveScreeningModule-module__p-t-12___Ja6_E {
  padding-top: 12px !important;
}

.CognitiveScreeningModule-module__p-t-16___lK8sx {
  padding-top: 16px !important;
}

.CognitiveScreeningModule-module__p-t-18___qJ2Ta {
  padding-top: 18px !important;
}

.CognitiveScreeningModule-module__p-t-20___GRaAf {
  padding-top: 20px !important;
}

.CognitiveScreeningModule-module__p-t-30___JIvDr {
  padding-top: 30px !important;
}

.CognitiveScreeningModule-module__p-t-40___yu64h {
  padding-top: 40px !important;
}

.CognitiveScreeningModule-module__p-t-50___ymSk3 {
  padding-top: 50px !important;
}

.CognitiveScreeningModule-module__p-l-20___o7wx8 {
  padding-left: 20px !important;
}

.CognitiveScreeningModule-module__p-l-30___xdfOL {
  padding-left: 30px !important;
}

.CognitiveScreeningModule-module__p-l-40___H4YQW {
  padding-left: 40px !important;
}

.CognitiveScreeningModule-module__p-r-16___YLt1P {
  padding-right: 16px !important;
}

.CognitiveScreeningModule-module__p-r-20___beU2H {
  padding-right: 20px !important;
}

.CognitiveScreeningModule-module__p-r-30___LtP3Q {
  padding-right: 30px !important;
}

.CognitiveScreeningModule-module__p-r-50___N1NBB {
  padding-right: 50px !important;
}

.CognitiveScreeningModule-module__p-r-60___nzDkG {
  padding-right: 60px !important;
}

.CognitiveScreeningModule-module__m-b-1____Hypu {
  margin-bottom: 1px !important;
}

.CognitiveScreeningModule-module__m-b-2___Ig6in {
  margin-bottom: 2px !important;
}

.CognitiveScreeningModule-module__m-b-6___UJhpQ {
  margin-bottom: 6px !important;
}

.CognitiveScreeningModule-module__m-b-8___xzxve {
  margin-bottom: 8px !important;
}

.CognitiveScreeningModule-module__m-b-10___UQf76 {
  margin-bottom: 10px !important;
}

.CognitiveScreeningModule-module__m-b-14___OsQRt {
  margin-bottom: 14px !important;
}

.CognitiveScreeningModule-module__m-b-16___B9Lhu {
  margin-bottom: 16px !important;
}

.CognitiveScreeningModule-module__m-b-20___d9pDX {
  margin-bottom: 20px !important;
}

.CognitiveScreeningModule-module__m-b-22___m4x4l {
  margin-bottom: 22px !important;
}

.CognitiveScreeningModule-module__m-b-24___N8514 {
  margin-bottom: 24px !important;
}

.CognitiveScreeningModule-module__m-b-30___ZqWT5 {
  margin-bottom: 30px !important;
}

.CognitiveScreeningModule-module__m-b-32___Ro264 {
  margin-bottom: 32px !important;
}

.CognitiveScreeningModule-module__m-b-40___wrMjj {
  margin-bottom: 40px !important;
}

.CognitiveScreeningModule-module__m-t-2___gwEjn {
  margin-top: 2px !important;
}

.CognitiveScreeningModule-module__m-t-3___cJ5Hy {
  margin-top: 3px !important;
}

.CognitiveScreeningModule-module__m-t-4___Njwp_ {
  margin-top: 4px !important;
}

.CognitiveScreeningModule-module__m-t-5____Vyco {
  margin-top: 5px !important;
}

.CognitiveScreeningModule-module__m-t-8___mUhvK {
  margin-top: 8px !important;
}

.CognitiveScreeningModule-module__m-t-10___u61Sv {
  margin-top: 10px !important;
}

.CognitiveScreeningModule-module__m-t-15___pMKjD {
  margin-top: 15px !important;
}

.CognitiveScreeningModule-module__m-t-16___wxQre {
  margin-top: 16px !important;
}

.CognitiveScreeningModule-module__m-t-20___Q70Fj {
  margin-top: 20px !important;
}

.CognitiveScreeningModule-module__m-t-22___Dck_q {
  margin-top: 22px !important;
}

.CognitiveScreeningModule-module__m-t-30___AYMF_ {
  margin-top: 30px !important;
}

.CognitiveScreeningModule-module__m-t-32___loLmx {
  margin-top: 32px !important;
}

.CognitiveScreeningModule-module__m-l-auto___hBnjZ {
  margin-left: auto !important;
}

.CognitiveScreeningModule-module__m-l-4___DnX5O {
  margin-left: 4px !important;
}

.CognitiveScreeningModule-module__m-l-5___XfqLO {
  margin-left: 5px !important;
}

.CognitiveScreeningModule-module__m-l-6___wNUA3 {
  margin-left: 6px !important;
}

.CognitiveScreeningModule-module__m-l-8___QY6KJ {
  margin-left: 8px !important;
}

.CognitiveScreeningModule-module__m-l-10___yninq {
  margin-left: 10px !important;
}

.CognitiveScreeningModule-module__m-l-16___neqEx {
  margin-left: 16px !important;
}

.CognitiveScreeningModule-module__m-l-20___LfGJZ {
  margin-left: 20px !important;
}

.CognitiveScreeningModule-module__m-l-24___u5Sra {
  margin-left: 24px !important;
}

.CognitiveScreeningModule-module__m-l-30___JeL7r {
  margin-left: 30px !important;
}

.CognitiveScreeningModule-module__m-l-35___pQVIK {
  margin-left: 35px !important;
}

.CognitiveScreeningModule-module__m-l-40___QXSIe {
  margin-left: 40px !important;
}

.CognitiveScreeningModule-module__m-r-8___i5Kyq {
  margin-right: 8px !important;
}

.CognitiveScreeningModule-module__m-r-10___Bf7Ud {
  margin-right: 10px !important;
}

.CognitiveScreeningModule-module__m-r-16___B3Oq6 {
  margin-right: 16px !important;
}

.CognitiveScreeningModule-module__m-r-20___v6XwC {
  margin-right: 20px !important;
}

.CognitiveScreeningModule-module__m-r-24___rNKUE {
  margin-right: 24px !important;
}

.CognitiveScreeningModule-module__m-r-30___zsvFD {
  margin-right: 30px !important;
}

.CognitiveScreeningModule-module__m-r-40___msQKE {
  margin-right: 40px !important;
}

.CognitiveScreeningModule-module__border-r-3___uqTHQ {
  border-radius: 3px !important;
}

.CognitiveScreeningModule-module__border-r-4___WcD0i {
  border-radius: 4px !important;
}

.CognitiveScreeningModule-module__border-r-6___yYl7G {
  border-radius: 6px !important;
}

.CognitiveScreeningModule-module__border-r-10___J6P9M {
  border-radius: 10px !important;
}

.CognitiveScreeningModule-module__border-r-12___k2gy7 {
  border-radius: 12px !important;
}

.CognitiveScreeningModule-module__border-r-16___QD4Dn {
  border-radius: 16px !important;
}

.CognitiveScreeningModule-module__border-r-50___jGEUK {
  border-radius: 50% !important;
}

.CognitiveScreeningModule-module__primary-border___CFqfe {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveScreeningModule-module__primary-border-b___wKxAw {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveScreeningModule-module__primary-border-t___bDcW5 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveScreeningModule-module__primary-border-l___rtvPw {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveScreeningModule-module__primary-border-r___unpiR {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CognitiveScreeningModule-module__secondary-border___OwNhb {
  border: 1px solid #637768;
}

.CognitiveScreeningModule-module__secondary-border-b___RgCKB {
  border-bottom: 1px solid #637768;
}

.CognitiveScreeningModule-module__secondary-border-t___kubPQ {
  border-top: 1px solid #637768;
}

.CognitiveScreeningModule-module__secondary-border-l___vifTA {
  border-left: 1px solid #637768;
}

.CognitiveScreeningModule-module__secondary-border-r___WJIw7 {
  border-right: 1px solid #637768;
}

.CognitiveScreeningModule-module__gap-0___enFrb {
  gap: 0 !important;
}

.CognitiveScreeningModule-module__gap-2___x8ynR {
  gap: 2px !important;
}

.CognitiveScreeningModule-module__gap-4___nFcsO {
  gap: 4px !important;
}

.CognitiveScreeningModule-module__gap-5___RgG5r {
  gap: 5px !important;
}

.CognitiveScreeningModule-module__gap-6___JFCay {
  gap: 6px !important;
}

.CognitiveScreeningModule-module__gap-8___o3n8e {
  gap: 8px !important;
}

.CognitiveScreeningModule-module__gap-10___KUKW7 {
  gap: 10px !important;
}

.CognitiveScreeningModule-module__gap-12___ve6ba {
  gap: 12px !important;
}

.CognitiveScreeningModule-module__gap-14___SQvab {
  gap: 14px !important;
}

.CognitiveScreeningModule-module__gap-16___f5lAo {
  gap: 16px !important;
}

.CognitiveScreeningModule-module__gap-18___ceNE2 {
  gap: 18px !important;
}

.CognitiveScreeningModule-module__gap-20___vmwFd {
  gap: 20px !important;
}

.CognitiveScreeningModule-module__gap-24___n1_2s {
  gap: 24px !important;
}

.CognitiveScreeningModule-module__gap-26___noxCQ {
  gap: 26px !important;
}

.CognitiveScreeningModule-module__gap-30___pddKL {
  gap: 30px !important;
}

.CognitiveScreeningModule-module__gap-32___EhedJ {
  gap: 32px !important;
}

.CognitiveScreeningModule-module__gap-40___Hjn2A {
  gap: 40px !important;
}

.CognitiveScreeningModule-module__gap-50___i6P7h {
  gap: 50px !important;
}

.CognitiveScreeningModule-module__flex-1___W7JOp {
  flex: 1;
}

.CognitiveScreeningModule-module__flex-none___z4zOn {
  flex: none !important;
}

.CognitiveScreeningModule-module__flex-column___bqRBV {
  display: flex;
  flex-direction: column !important;
}

.CognitiveScreeningModule-module__flex-row___P4Zm4 {
  display: flex;
  flex-direction: row !important;
}

.CognitiveScreeningModule-module__vertically-centered___B97fl {
  display: flex;
  align-items: center !important;
}

.CognitiveScreeningModule-module__horizontally-centered___zmO0A {
  display: flex;
  justify-content: center !important;
}

.CognitiveScreeningModule-module__horizontally-end___F93SQ {
  display: flex;
  justify-content: end !important;
}

.CognitiveScreeningModule-module__vertically-start___H0PDX {
  display: flex;
  align-items: start !important;
}

.CognitiveScreeningModule-module__space-between___qkBe8 {
  display: flex;
  justify-content: space-between !important;
}

.CognitiveScreeningModule-module__flex-wrap___rczEP {
  flex-wrap: wrap !important;
}

.CognitiveScreeningModule-module__height-100___KFl9k {
  height: 100%;
}

.CognitiveScreeningModule-module__width-50____4H1i {
  width: 50% !important;
}

.CognitiveScreeningModule-module__width-100___fMbrI {
  width: 100%;
}

.CognitiveScreeningModule-module__cursor-pointer___cuaFM {
  cursor: pointer;
}

.CognitiveScreeningModule-module__cursor-not-allowed___fFU31 {
  cursor: not-allowed !important;
}

.CognitiveScreeningModule-module__absolute-centered___vggn7 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CognitiveScreeningModule-module__absolute___IfnpD {
  position: absolute;
}

.CognitiveScreeningModule-module__relative___MD2fy {
  position: relative;
}

.CognitiveScreeningModule-module__fixed___cGABr {
  position: fixed;
}

.CognitiveScreeningModule-module__visible____UB7l {
  opacity: 1;
}

.CognitiveScreeningModule-module__invisible___jwR4m {
  opacity: 0;
}

.CognitiveScreeningModule-module__col-90___OXO6y {
  width: 90% !important;
}

.CognitiveScreeningModule-module__col-auto___dA97J {
  width: auto !important;
}

.CognitiveScreeningModule-module__medical-tabs___WIq1G {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CognitiveScreeningModule-module__medical-table-new___twIzq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CognitiveScreeningModule-module__medical-table-new___twIzq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CognitiveScreeningModule-module__medical-table-new___twIzq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CognitiveScreeningModule-module__medical-table-new___twIzq::-webkit-scrollbar-track {
  display: none;
}
.CognitiveScreeningModule-module__medical-table-new___twIzq.CognitiveScreeningModule-module__no-pagination___Swbvk {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CognitiveScreeningModule-module__medical-table-new___twIzq.CognitiveScreeningModule-module__no-pagination___Swbvk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CognitiveScreeningModule-module__medical-table-new___twIzq.CognitiveScreeningModule-module__no-pagination___Swbvk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CognitiveScreeningModule-module__medical-table-new___twIzq.CognitiveScreeningModule-module__no-pagination___Swbvk::-webkit-scrollbar-track {
  display: none;
}

.CognitiveScreeningModule-module__medical-table-empty___BnGUd {
  padding: 14px 40px !important;
}

.CognitiveScreeningModule-module__icon-btn___JG0HI {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CognitiveScreeningModule-module__search-icon___aGiAb {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CognitiveScreeningModule-module__disable-select___MvGj1 {
  user-select: none;
}

.CognitiveScreeningModule-module__break-word___B5Apb {
  word-break: break-word;
}

.CognitiveScreeningModule-module__popup-clear-btn___Le_u7 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CognitiveScreeningModule-module__scroll-m-b-20___pyFlW {
  scroll-margin-bottom: 20px;
}

.CognitiveScreeningModule-module__container___Q16r_ {
  color: #375844;
  padding-top: 14px;
}
.CognitiveScreeningModule-module__container___Q16r_ .CognitiveScreeningModule-module__textArea____q4FY {
  caret-color: transparent;
  width: 66%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/CognitiveScreeningModule/CognitiveScreeningModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,iBAAA;AA8pBF;AA5pBE;EACE,wBAAA;EACA,UAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  padding-top: 14px;\n\n  .textArea {\n    caret-color: transparent;\n    width: 66%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CognitiveScreeningModule-module__font-s-10___aforJ`,
	"fontS12": `CognitiveScreeningModule-module__font-s-12___lMH6g`,
	"fontS13": `CognitiveScreeningModule-module__font-s-13___OuA68`,
	"fontS14": `CognitiveScreeningModule-module__font-s-14___c76oz`,
	"fontS15": `CognitiveScreeningModule-module__font-s-15___WCUIm`,
	"fontS16": `CognitiveScreeningModule-module__font-s-16___mVNkb`,
	"fontS18": `CognitiveScreeningModule-module__font-s-18___PcmPz`,
	"fontS20": `CognitiveScreeningModule-module__font-s-20___H37bR`,
	"fontS22": `CognitiveScreeningModule-module__font-s-22___hTyRF`,
	"fontS28": `CognitiveScreeningModule-module__font-s-28___Hbq1B`,
	"fontW400": `CognitiveScreeningModule-module__font-w-400___QoDHE`,
	"fontW500": `CognitiveScreeningModule-module__font-w-500___t6jXc`,
	"fontW600": `CognitiveScreeningModule-module__font-w-600___EoQSN`,
	"fontW700": `CognitiveScreeningModule-module__font-w-700____qnvG`,
	"p5": `CognitiveScreeningModule-module__p-5___uyw1s`,
	"p12": `CognitiveScreeningModule-module__p-12___zuHtB`,
	"p16": `CognitiveScreeningModule-module__p-16___MVLSF`,
	"p30": `CognitiveScreeningModule-module__p-30___kxaIf`,
	"pB0": `CognitiveScreeningModule-module__p-b-0___Aw6Vj`,
	"pB5": `CognitiveScreeningModule-module__p-b-5___AjRbY`,
	"pB10": `CognitiveScreeningModule-module__p-b-10___rHTjV`,
	"pB12": `CognitiveScreeningModule-module__p-b-12___bWPvi`,
	"pB16": `CognitiveScreeningModule-module__p-b-16___FOO6d`,
	"pB18": `CognitiveScreeningModule-module__p-b-18___BiNvf`,
	"pB20": `CognitiveScreeningModule-module__p-b-20___ohCpn`,
	"pB25": `CognitiveScreeningModule-module__p-b-25___iaKZM`,
	"pB30": `CognitiveScreeningModule-module__p-b-30___cQmo3`,
	"pB50": `CognitiveScreeningModule-module__p-b-50___dkf0b`,
	"pT0": `CognitiveScreeningModule-module__p-t-0___UBjF2`,
	"pT12": `CognitiveScreeningModule-module__p-t-12___Ja6_E`,
	"pT16": `CognitiveScreeningModule-module__p-t-16___lK8sx`,
	"pT18": `CognitiveScreeningModule-module__p-t-18___qJ2Ta`,
	"pT20": `CognitiveScreeningModule-module__p-t-20___GRaAf`,
	"pT30": `CognitiveScreeningModule-module__p-t-30___JIvDr`,
	"pT40": `CognitiveScreeningModule-module__p-t-40___yu64h`,
	"pT50": `CognitiveScreeningModule-module__p-t-50___ymSk3`,
	"pL20": `CognitiveScreeningModule-module__p-l-20___o7wx8`,
	"pL30": `CognitiveScreeningModule-module__p-l-30___xdfOL`,
	"pL40": `CognitiveScreeningModule-module__p-l-40___H4YQW`,
	"pR16": `CognitiveScreeningModule-module__p-r-16___YLt1P`,
	"pR20": `CognitiveScreeningModule-module__p-r-20___beU2H`,
	"pR30": `CognitiveScreeningModule-module__p-r-30___LtP3Q`,
	"pR50": `CognitiveScreeningModule-module__p-r-50___N1NBB`,
	"pR60": `CognitiveScreeningModule-module__p-r-60___nzDkG`,
	"mB1": `CognitiveScreeningModule-module__m-b-1____Hypu`,
	"mB2": `CognitiveScreeningModule-module__m-b-2___Ig6in`,
	"mB6": `CognitiveScreeningModule-module__m-b-6___UJhpQ`,
	"mB8": `CognitiveScreeningModule-module__m-b-8___xzxve`,
	"mB10": `CognitiveScreeningModule-module__m-b-10___UQf76`,
	"mB14": `CognitiveScreeningModule-module__m-b-14___OsQRt`,
	"mB16": `CognitiveScreeningModule-module__m-b-16___B9Lhu`,
	"mB20": `CognitiveScreeningModule-module__m-b-20___d9pDX`,
	"mB22": `CognitiveScreeningModule-module__m-b-22___m4x4l`,
	"mB24": `CognitiveScreeningModule-module__m-b-24___N8514`,
	"mB30": `CognitiveScreeningModule-module__m-b-30___ZqWT5`,
	"mB32": `CognitiveScreeningModule-module__m-b-32___Ro264`,
	"mB40": `CognitiveScreeningModule-module__m-b-40___wrMjj`,
	"mT2": `CognitiveScreeningModule-module__m-t-2___gwEjn`,
	"mT3": `CognitiveScreeningModule-module__m-t-3___cJ5Hy`,
	"mT4": `CognitiveScreeningModule-module__m-t-4___Njwp_`,
	"mT5": `CognitiveScreeningModule-module__m-t-5____Vyco`,
	"mT8": `CognitiveScreeningModule-module__m-t-8___mUhvK`,
	"mT10": `CognitiveScreeningModule-module__m-t-10___u61Sv`,
	"mT15": `CognitiveScreeningModule-module__m-t-15___pMKjD`,
	"mT16": `CognitiveScreeningModule-module__m-t-16___wxQre`,
	"mT20": `CognitiveScreeningModule-module__m-t-20___Q70Fj`,
	"mT22": `CognitiveScreeningModule-module__m-t-22___Dck_q`,
	"mT30": `CognitiveScreeningModule-module__m-t-30___AYMF_`,
	"mT32": `CognitiveScreeningModule-module__m-t-32___loLmx`,
	"mLAuto": `CognitiveScreeningModule-module__m-l-auto___hBnjZ`,
	"mL4": `CognitiveScreeningModule-module__m-l-4___DnX5O`,
	"mL5": `CognitiveScreeningModule-module__m-l-5___XfqLO`,
	"mL6": `CognitiveScreeningModule-module__m-l-6___wNUA3`,
	"mL8": `CognitiveScreeningModule-module__m-l-8___QY6KJ`,
	"mL10": `CognitiveScreeningModule-module__m-l-10___yninq`,
	"mL16": `CognitiveScreeningModule-module__m-l-16___neqEx`,
	"mL20": `CognitiveScreeningModule-module__m-l-20___LfGJZ`,
	"mL24": `CognitiveScreeningModule-module__m-l-24___u5Sra`,
	"mL30": `CognitiveScreeningModule-module__m-l-30___JeL7r`,
	"mL35": `CognitiveScreeningModule-module__m-l-35___pQVIK`,
	"mL40": `CognitiveScreeningModule-module__m-l-40___QXSIe`,
	"mR8": `CognitiveScreeningModule-module__m-r-8___i5Kyq`,
	"mR10": `CognitiveScreeningModule-module__m-r-10___Bf7Ud`,
	"mR16": `CognitiveScreeningModule-module__m-r-16___B3Oq6`,
	"mR20": `CognitiveScreeningModule-module__m-r-20___v6XwC`,
	"mR24": `CognitiveScreeningModule-module__m-r-24___rNKUE`,
	"mR30": `CognitiveScreeningModule-module__m-r-30___zsvFD`,
	"mR40": `CognitiveScreeningModule-module__m-r-40___msQKE`,
	"borderR3": `CognitiveScreeningModule-module__border-r-3___uqTHQ`,
	"borderR4": `CognitiveScreeningModule-module__border-r-4___WcD0i`,
	"borderR6": `CognitiveScreeningModule-module__border-r-6___yYl7G`,
	"borderR10": `CognitiveScreeningModule-module__border-r-10___J6P9M`,
	"borderR12": `CognitiveScreeningModule-module__border-r-12___k2gy7`,
	"borderR16": `CognitiveScreeningModule-module__border-r-16___QD4Dn`,
	"borderR50": `CognitiveScreeningModule-module__border-r-50___jGEUK`,
	"primaryBorder": `CognitiveScreeningModule-module__primary-border___CFqfe`,
	"primaryBorderB": `CognitiveScreeningModule-module__primary-border-b___wKxAw`,
	"primaryBorderT": `CognitiveScreeningModule-module__primary-border-t___bDcW5`,
	"primaryBorderL": `CognitiveScreeningModule-module__primary-border-l___rtvPw`,
	"primaryBorderR": `CognitiveScreeningModule-module__primary-border-r___unpiR`,
	"secondaryBorder": `CognitiveScreeningModule-module__secondary-border___OwNhb`,
	"secondaryBorderB": `CognitiveScreeningModule-module__secondary-border-b___RgCKB`,
	"secondaryBorderT": `CognitiveScreeningModule-module__secondary-border-t___kubPQ`,
	"secondaryBorderL": `CognitiveScreeningModule-module__secondary-border-l___vifTA`,
	"secondaryBorderR": `CognitiveScreeningModule-module__secondary-border-r___WJIw7`,
	"gap0": `CognitiveScreeningModule-module__gap-0___enFrb`,
	"gap2": `CognitiveScreeningModule-module__gap-2___x8ynR`,
	"gap4": `CognitiveScreeningModule-module__gap-4___nFcsO`,
	"gap5": `CognitiveScreeningModule-module__gap-5___RgG5r`,
	"gap6": `CognitiveScreeningModule-module__gap-6___JFCay`,
	"gap8": `CognitiveScreeningModule-module__gap-8___o3n8e`,
	"gap10": `CognitiveScreeningModule-module__gap-10___KUKW7`,
	"gap12": `CognitiveScreeningModule-module__gap-12___ve6ba`,
	"gap14": `CognitiveScreeningModule-module__gap-14___SQvab`,
	"gap16": `CognitiveScreeningModule-module__gap-16___f5lAo`,
	"gap18": `CognitiveScreeningModule-module__gap-18___ceNE2`,
	"gap20": `CognitiveScreeningModule-module__gap-20___vmwFd`,
	"gap24": `CognitiveScreeningModule-module__gap-24___n1_2s`,
	"gap26": `CognitiveScreeningModule-module__gap-26___noxCQ`,
	"gap30": `CognitiveScreeningModule-module__gap-30___pddKL`,
	"gap32": `CognitiveScreeningModule-module__gap-32___EhedJ`,
	"gap40": `CognitiveScreeningModule-module__gap-40___Hjn2A`,
	"gap50": `CognitiveScreeningModule-module__gap-50___i6P7h`,
	"flex1": `CognitiveScreeningModule-module__flex-1___W7JOp`,
	"flexNone": `CognitiveScreeningModule-module__flex-none___z4zOn`,
	"flexColumn": `CognitiveScreeningModule-module__flex-column___bqRBV`,
	"flexRow": `CognitiveScreeningModule-module__flex-row___P4Zm4`,
	"verticallyCentered": `CognitiveScreeningModule-module__vertically-centered___B97fl`,
	"horizontallyCentered": `CognitiveScreeningModule-module__horizontally-centered___zmO0A`,
	"horizontallyEnd": `CognitiveScreeningModule-module__horizontally-end___F93SQ`,
	"verticallyStart": `CognitiveScreeningModule-module__vertically-start___H0PDX`,
	"spaceBetween": `CognitiveScreeningModule-module__space-between___qkBe8`,
	"flexWrap": `CognitiveScreeningModule-module__flex-wrap___rczEP`,
	"height100": `CognitiveScreeningModule-module__height-100___KFl9k`,
	"width50": `CognitiveScreeningModule-module__width-50____4H1i`,
	"width100": `CognitiveScreeningModule-module__width-100___fMbrI`,
	"cursorPointer": `CognitiveScreeningModule-module__cursor-pointer___cuaFM`,
	"cursorNotAllowed": `CognitiveScreeningModule-module__cursor-not-allowed___fFU31`,
	"absoluteCentered": `CognitiveScreeningModule-module__absolute-centered___vggn7`,
	"absolute": `CognitiveScreeningModule-module__absolute___IfnpD`,
	"relative": `CognitiveScreeningModule-module__relative___MD2fy`,
	"fixed": `CognitiveScreeningModule-module__fixed___cGABr`,
	"visible": `CognitiveScreeningModule-module__visible____UB7l`,
	"invisible": `CognitiveScreeningModule-module__invisible___jwR4m`,
	"col90": `CognitiveScreeningModule-module__col-90___OXO6y`,
	"colAuto": `CognitiveScreeningModule-module__col-auto___dA97J`,
	"medicalTabs": `CognitiveScreeningModule-module__medical-tabs___WIq1G`,
	"medicalTableNew": `CognitiveScreeningModule-module__medical-table-new___twIzq`,
	"noPagination": `CognitiveScreeningModule-module__no-pagination___Swbvk`,
	"medicalTableEmpty": `CognitiveScreeningModule-module__medical-table-empty___BnGUd`,
	"iconBtn": `CognitiveScreeningModule-module__icon-btn___JG0HI`,
	"searchIcon": `CognitiveScreeningModule-module__search-icon___aGiAb`,
	"disableSelect": `CognitiveScreeningModule-module__disable-select___MvGj1`,
	"breakWord": `CognitiveScreeningModule-module__break-word___B5Apb`,
	"popupClearBtn": `CognitiveScreeningModule-module__popup-clear-btn___Le_u7`,
	"scrollMB20": `CognitiveScreeningModule-module__scroll-m-b-20___pyFlW`,
	"container": `CognitiveScreeningModule-module__container___Q16r_`,
	"textArea": `CognitiveScreeningModule-module__textArea____q4FY`
};
module.exports = ___CSS_LOADER_EXPORT___;
